import React from 'react';
import { Card } from '@perch-labs/shrike';
import Sticky from 'react-sticky-el';
import { Selector } from '../selector';
import { Content } from '../content';

const offset = 96;

export const Desktop = () => (
  <Sticky
    topOffset={-offset}
    stickyStyle={{
      marginTop: `${offset}px`,
    }}
  >
    <Card data-testid="desktop-usage">
      <Selector />
      <Content />
    </Card>
  </Sticky>
);
